// extracted by mini-css-extract-plugin
export var accountAvatar = "gVcCQQQe_2vkP0ACBdxt";
export var accountAvatarBadge = "hXrh5PyzK1en5X5o3bLg";
export var accountAvatarContainer = "dT0ExmJMfyWndrUM3BCH";